import { Gem } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { ROLE_LABEL } from '@/types/user'

/** Top bar shared by every authenticated view: brand, role chip, email, sign-out. */
export function AppHeader() {
  const { user, role, logout } = useAuth()
  const navigate = useNavigate()

  async function handleLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <header className="flex items-center justify-between border-b border-slate-200 bg-white px-4 py-3">
      <div className="flex items-center gap-3">
        <span className="flex items-center gap-1.5 text-lg font-bold text-primary">
          <Gem className="h-5 w-5" aria-hidden="true" />
          Semaphore Minerals
        </span>
        {role && (
          <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">
            {ROLE_LABEL[role]}
          </span>
        )}
      </div>
      <div className="flex items-center gap-3 text-sm text-slate-600">
        <span className="hidden sm:inline">{user?.email}</span>
        <button
          type="button"
          onClick={handleLogout}
          className="rounded-lg border border-slate-300 px-3 py-1.5 font-medium hover:bg-slate-50"
        >
          Sign out
        </button>
      </div>
    </header>
  )
}
